var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    id: "svg513",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs517"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 0.69438278,3.6285719 5.4299469,0.1854566 C 5.5971568,0.06537005 5.8040418,4.7234464e-5 6.0171538,4.72514e-5 6.2302658,4.7268336e-5 6.4371508,0.06537005 6.6043606,0.1854566 l 4.7355224,3.4431153 c 0.172559,0.1480228 0.277685,0.3495173 0.294621,0.5646224 0.01694,0.215105 -0.05566,0.4281344 -0.203333,0.5969449 C 11.283603,4.95896 11.071595,5.0712525 10.837179,5.1048142 10.602764,5.138376 10.363081,5.0907596 10.165531,4.971383 L 6.9642666,2.6472777 V 11.13104 c 0,0.22822 -0.099787,0.447249 -0.277406,0.608655 -0.1776191,0.161406 -0.4185203,0.252075 -0.6697068,0.252075 -0.2511969,0 -0.492098,-0.09067 -0.6697068,-0.252075 C 5.1698278,11.578289 5.070041,11.35926 5.070041,11.13104 V 2.6472777 L 1.8688068,4.971383 C 1.7734295,5.0532014 1.6604038,5.116122 1.5368759,5.1561689 1.4133479,5.1962158 1.282013,5.212501 1.1512048,5.2040125 1.0203862,5.1955239 0.89293414,5.1624269 0.77692405,5.1068279 0.66091293,5.0512393 0.55887176,4.9743468 0.47726402,4.8810348 0.39565628,4.7877331 0.33626229,4.680036 0.30284201,4.5647694 0.26942172,4.4495132 0.26270421,4.3291968 0.28311492,4.2114622 0.30352667,4.0937172 0.35062156,3.9811046 0.42141725,3.8807704 0.49221191,3.7804363 0.58516559,3.6945491 0.69438278,3.6285719 Z",
    fill: "#283856",
    id: "path511",
    style: {
      strokeWidth: 1.03267
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.a511831b6014206bf0ded3e46a896d81.svg";
export { ForwardRef as ReactComponent };